import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api, clearToken } from '../utils/api';
import LanguageSwitcher from './LanguageSwitcher';
import BrandMark from './BrandMark';
import { useI18n } from '../i18n/I18nProvider';

const Icon = ({ children }) => (
  <svg
    className="uh-nav-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

const DashboardIcon = () => (
  <Icon>
    <rect x="3" y="3" width="7" height="9" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" />
  </Icon>
);

const ProjectsIcon = () => (
  <Icon>
    <path d="M3 7.5A1.5 1.5 0 0 1 4.5 6h4l2 2H19.5A1.5 1.5 0 0 1 21 9.5v8A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" />
  </Icon>
);

const AccountIcon = () => (
  <Icon>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
  </Icon>
);

const LogoutIcon = () => (
  <Icon>
    <path d="M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15" />
    <path d="M10 16l-4-4 4-4" />
    <path d="M6 12h11" />
  </Icon>
);

const NavItem = ({ to, label, icon }) => {
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(to + '/');
  return (
    <li className={active ? 'uh-nav-item active' : 'uh-nav-item'}>
      <Link to={to}>
        {icon}
        <span>{label}</span>
      </Link>
    </li>
  );
};

const Sidebar = () => {
  const { t } = useI18n();

  const handleLogout = async () => {
    try {
      await api.logout();
    } catch (_) { /* ignore — still log out locally */ }
    clearToken();
    const landing = (window.ENV && window.ENV.LANDING_URL) || '/';
    window.location.href = landing;
  };

  return (
    <nav className="uh-sidebar">
      <div className="uh-sidebar-top">
        <div className="uh-brand"><BrandMark size={24} />{t('app.brand')}</div>
        <LanguageSwitcher />
      </div>
      <ul className="uh-nav">
        <NavItem to="/dashboard" label={t('nav.dashboard')} icon={<DashboardIcon />} />
        <NavItem to="/projects"  label={t('nav.projects')}  icon={<ProjectsIcon />} />
        <NavItem to="/account"   label={t('nav.account')}   icon={<AccountIcon />} />
      </ul>
      <div className="uh-sidebar-footer">
        <button className="uh-btn uh-btn-sm" onClick={handleLogout} style={{ width: '100%' }}>
          <LogoutIcon />
          <span>{t('nav.logout')}</span>
        </button>
      </div>
    </nav>
  );
};

export default Sidebar;
